import { useMemo } from 'react';
import { useStoreDetails } from '../../../common/Providers/StoreDetailsProvider/UseStoreDetails';
import { 
  DrivingQuestionsConfig, 
  validateDrivingQuestionsConfig,
  resolveTemplateString
} from './DrivingQuestionsConfig';
import { FULL_CONFIG, EMPTY_CONFIG } from './ConfigExamples';

export const useDrivingQuestionsConfig = () => {
  const { storeDetails } = useStoreDetails();

  const config = useMemo(() => {
    // Get the dynamic config from storeDetails
    const cmsConfig = storeDetails?.driving_questions_config;
    
    // Validate CMS config
    if (cmsConfig && validateDrivingQuestionsConfig(cmsConfig)) {
      return cmsConfig;
    }
    
    // Fallback to empty config if API returns invalid data
    console.warn('Invalid or missing driving questions config, using empty config');
    return EMPTY_CONFIG;
  }, [storeDetails?.driving_questions_config]);

  const processedConfig = useMemo(() => {
    return {
      ...config,
      driverSelection: config.driverSelection ? {
        ...config.driverSelection,
        prompt: resolveTemplateString(config.driverSelection.prompt, config),
      } : undefined,
      additionalDrivers: {
        ...config.additionalDrivers,
        prompt: resolveTemplateString(config.additionalDrivers.prompt, config),
        maxReachedMessage: resolveTemplateString(config.additionalDrivers.maxReachedMessage, config),
      },
    };
  }, [config]);

  return processedConfig;
};
